<div class="formulaBuilderDialog" *ngIf="isLoader==false">
  <img class="btnCloseFBDialog" src="../../../assets/cancel-white-18dp.svg" (click)="onCancelClick(true)"
       alt="close button">
  <div class="formulaBuilderDialogHeader" mat-dialog-title>Evaluate Formula</div>
  <div class="formulaBuilderDialogBody" mat-dialog-content>
    
    <form>
      <br />
      <div class="fbRowControl row">
        <div class="col-md-1">
          <label class="fbLabelControl" for="expression">Expression: </label>
        </div>
        <div class="col-md-11">
          <textarea class="fbControlExpression" rows="3" disabled="disabled">{{mainFormulaExpression}}</textarea>
        </div>
      </div>
      <div class="d-flex table-container fixed-height-evaluate-formula">
        <div class="col-12 fixed-height">
          <mat-table [dataSource]="formulaDataSource" matSort matSortActive="tags" matSortDirection="asc" matSortDisableClear>
            <ng-container matColumnDef="ConstantTag">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">Constants / Tags</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <span class="">{{element.tagId}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <input [disabled]="true" value="{{mainFormulaName}}" type="text" class="fbControl" />
                
              </mat-footer-cell>
            </ng-container>
            <ng-container matColumnDef="ValueDataSource">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">Value / Data Source</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <span class="">{{element.tagValue}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <input [disabled]="true" value="{{mainFormulaValue}}" type="text" class="fbControl" />
                
              </mat-footer-cell>
            </ng-container>
            <ng-container matColumnDef="UOM">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">UOM</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <span class="">{{element.uom}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                <input [disabled]="true" value="{{mainFormulaUOM}}" type="text" class="fbControl" />
                
              </mat-footer-cell>
            </ng-container>
            <ng-container matColumnDef="EntryType">
              <mat-header-cell *matHeaderCellDef class="heading2 custom-table-header">Manual Entry</mat-header-cell>
              <mat-cell *matCellDef="let element let rowIndex = index" class="regularText custom-mat-cell">
                <label for="manualEntry" *ngIf="element.entryType != 'C' && element.entryType != 'O'" name="manualEntry" class="switch fbControl fbControlSiConversion">
                  <input id="manualEntry" #manualEntry type="checkbox" [checked]="element.entryType == 'M'" [disabled]="true">
                  <span class="slider round"></span>.
                </label>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
            <mat-row *matRowDef="let rows; columns: displayedColumns;"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns;sticky: true" stickybits></mat-footer-row>
          </mat-table>
        </div>
      </div>
      <br />
      <div class="d-flex alignCenter mb-4">
        <button id="backBtn" type="submit" class="saveBtn2 primaryBtn mt-2" (click)="backEvaluate()">
          Back
        </button>
      </div>
    </form>
  </div>
</div>

<div class="widgetContainer" *ngIf="isLoader==true">
  <div class="loader"></div>
</div>
